import type { ContentPage } from "@/lib/content/types";

// CRM › Sales Performance › Multiple Currencies (leaf).
export const multipleCurrencies: ContentPage = {
  slug: "sales-performance/multiple-currencies",
  template: "hrmsFeature",
  seo: {
    title: "Multi-Currency CRM - Sell in Any Currency | GetBiz CRM",
    description: "Manage global sales with multi-currency support in GetBiz CRM. Quote and close in local currencies with live rates and consolidated reporting.",
    keywords: ["multi currency crm", "multiple currencies", "global sales crm", "currency conversion crm"],
    ogImage: "/assets/data/seoimages/multiple-currencies.webp",
  },
  leaf: {
    hero: {
      caption: "Multiple Currencies",
      title: "Sell and Report in Any Currency",
      description: "Quote, close and report across currencies with live exchange rates — so global deals stay accurate and consolidated.",
      h1: "caption",
    },
    split: {
      title: "Why Teams Choose Multiple Currencies",
      bullets: [
        { title: "Local-Currency Deals", description: "Let reps quote and close in the buyer’s currency." },
        { title: "Live Exchange Rates", description: "Keep values current with automatic rate updates." },
        { title: "Consolidated Reporting", description: "Roll all deals up into your base currency." },
        { title: "Global-Ready", description: "Support teams selling across many countries." },
      ],
      image: "/assets/images/img/product/crm/multiple-currencies-lead-image.webp",
      imageAlt: "Multiple Currencies — GetBiz CRM",
    },
    cardsHeading: {
      title: "Works With the Rest of Sales Performance",
      description: "Multiple Currencies connects to every other part of Sales Performance in GetBiz CRM.",
    },
    cards: [
      { title: "Forecasting", href: "/crm-software/sales-performance/forecasting/", description: "Build data-driven forecasts from your live pipeline, so leadership always has an accurate view of what will close.", image: "/assets/images/img/product/crm/forecasting.webp", imageAlt: "GetBiz CRM forecasting" },
      { title: "Analytics", href: "/crm-software/sales-performance/analytics/", description: "Dig into performance across reps, products and regions to understand the behaviors and deals that drive revenue.", image: "/assets/images/img/product/crm/analytics-sub.webp", imageAlt: "GetBiz CRM analytics" },
      { title: "Visitor Tracking", href: "/crm-software/sales-performance/visitor-tracking/", description: "Identify the companies browsing your site, see what they view, and turn anonymous traffic into warm, timely outreach.", image: "/assets/images/img/product/crm/visitor-tracking.webp", imageAlt: "GetBiz CRM visitor tracking" },
    ],
    testimonials: {
      title: "Businesses across India love & trust GetBiz!",
      description: "See why teams choose GetBiz CRM to run their sales.",
    },
    bookDemoTitle: "See Multiple Currencies in action.",
    relatedBlogs: "static",
    metaKey: "sales-performance-multiple-currencies",
  },
  sections: [],
};
